import React from 'react';
import PricingPageTableHeader from './PricingPageTableHeader';
import useStyles from './styles';
import PurchaseNowButton from '../PurchaseNowButton';
import { ProductCodes } from '../../../../../types/products';

const ProPackagesPricingPageTableHeader = () => {
  const classes = useStyles();

  return (
    <PricingPageTableHeader>
      <div className={classes.title}>Pro Packages</div>
      <div className={classes.description}>
        Video packages for those who want to create videos frequently over course of a year
      </div>
      <div className={classes.planTitle}>
        $1500
        {' '}
        <span className={classes.planDuration}>/ 24 videos</span>
      </div>
      <div className={classes.planDescription}>
        a year (save 30%)
      </div>
      <div className={classes.buttonWrapper}>
        <PurchaseNowButton productCode={ProductCodes.ProYear24videos} />
      </div>
      <div className={classes.planTitle}>
        $975
        {' '}
        <span className={classes.planDuration}>/ 12 videos</span>
      </div>
      <div className={classes.planDescription}>
        a year (save 9%)
      </div>
      <PurchaseNowButton
        productCode={ProductCodes.ProYear12videos}
        variant="outlined"
      />
    </PricingPageTableHeader>
  );
};

export default ProPackagesPricingPageTableHeader;
